// extracted by mini-css-extract-plugin
module.exports = {"bottomLeftMargin":"BasicInformationQuestionSetCheckbox_bottomLeftMargin__2Hfml","leftMargin":"BasicInformationQuestionSetCheckbox_leftMargin__1Axb9"};